import { render, staticRenderFns } from "./transaction_h_info.vue?vue&type=template&id=6f34891a&scoped=true"
import script from "./transaction_h_info.vue?vue&type=script&lang=js"
export * from "./transaction_h_info.vue?vue&type=script&lang=js"
import style0 from "./transaction_h_info.vue?vue&type=style&index=0&id=6f34891a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f34891a",
  null
  
)

export default component.exports